import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../../../utils/api";
import { Modal } from "../../../components/core/basic/Modal";
import { Center, VStack } from "../../../../styled-system/jsx";
import { TextField } from "../../../components/fields/base/TextField";
import { css } from "../../../../styled-system/css";
import { Button } from "../../../components/core/basic/Button";

const createCustomApp = async (shopName: string, apiKey: string, apiSecretKey: string, accessToken: string) => {
  await api.post("/shopify/custom-app", {
    shop: shopName,
    api_key: apiKey,
    api_secret_key: apiSecretKey,
    access_token: accessToken,
  });
};

interface Props {
  is_visible?: boolean;
  onHide: () => void;
  oauthUrl?: string;
}

const ShopifySetup = (props: Props) => {
  const { t } = useTranslation(["shopify"]);
  const [shopName, setShopName] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [apiSecretKey, setApiSecretKey] = useState("");
  const [accessToken, setAccessToken] = useState("");
  const [success, setSuccess] = useState(false);

  const onSubmit = async () => {
    if (shopName === "") {
      return;
    }

    if (apiKey === "" || apiSecretKey === "" || accessToken === "") {
      return;
    }

    await createCustomApp(shopName, apiKey, apiSecretKey, accessToken);
    setSuccess(true);
  };

  return (
    <Modal
      isOpen={props.is_visible}
      title={t(($) => $.shopify["Connect With Shopify"])}
      onOpenChange={(isOpen) => !isOpen && props.onHide()}
    >
      {success && <Center>{t(($) => $.shopify["Shopify store connected successfully!"])}</Center>}
      {!success && (
        <VStack alignItems={"stretch"} paddingX={"xlarge"}>
          <h4 className={css({ margin: 0 })}>
            {t(($) => $.shopify["Enter the custom API credentials for your Shopify store."])}
          </h4>
          <TextField
            label={t(($) => $.shopify["Store name"])}
            placeholder={t(($) => $.shopify["my-shop"])}
            endIcon={".myshopify.com"}
            value={shopName}
            onChange={setShopName}
          />
          <TextField label={t(($) => $.shopify["API Key"])} value={apiKey} onChange={setApiKey} />
          <TextField label={t(($) => $.shopify["API Secret Key"])} value={apiSecretKey} onChange={setApiSecretKey} />
          <TextField label={t(($) => $.shopify["Access Token"])} value={accessToken} onChange={setAccessToken} />

          <Center>
            <Button onPress={() => void onSubmit()}>{t(($) => $.shopify["Connect To Shopify"])}</Button>
          </Center>
        </VStack>
      )}
    </Modal>
  );
};

export default ShopifySetup;
